module.exports = __webpack_public_path__ + "img/qr2.f33dedb3.jpg";